module.exports = __webpack_public_path__ + "img/img_login.340b877d.png";